import { Link } from 'react-router-dom';
import { notification } from 'antd';

import { DefaultPageTemplate } from '@/modules/common/components/default-page-template';
import { UiButton } from '@/modules/ui/components/ui-button';
import { Responses } from '@consta/uikit/Responses';
import ResponseLogo from '../../images/ResponseLogo';

import styles from './index.module.sass';


export const ForbiddenPage = () => {

    const handleCopyClick = () => {
        navigator.clipboard.writeText('88005559983');
        notification.success({
            message: 'Номер телефона скопирован',
          });
    };

  return (
    <DefaultPageTemplate className={styles.root}>
      <Responses
        title="У вас недостаточно прав для доступа к этой странице"
        image={ResponseLogo}
        description={
            <div className={styles.description}>
              Для расширения тарифного плана, обратитесь, пожалуйста в{' '}
              <br />
              Отдел продаж, по номеру телефона: <br /> <b
              onClick={handleCopyClick}
              className={styles.link}
              >8 (800) 555-99-83</b>
            </div>
          }
        actions={
          <Link to="/">
            <UiButton label="На главную" />
          </Link>
        }
      />
    </DefaultPageTemplate>
  );
}
